import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { GLOBAL_TOAST } from '../constants/toastConstant';

export const uploadDocument = async (data) => {
  const { formData, config } = data;
  try {
    const response = await Instance.post(`${API.UPLOAD_DOCUMENT}`, formData, {
      headers: config?.headers,
    });
    if (response.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
    }
    return response;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
    return error;
  }
};

export const getUserEmailFromAccessToken = async (accessToken) => {
  try {
    const response = await fetch(
      'https://www.googleapis.com/oauth2/v3/userinfo',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch user info: ${response.statusText}`);
    }
    const data = await response.json();
    return data.email; // This will contain the email address
  } catch (error) {
    console.error('Error fetching user email:', error);
    return null;
  }
};

export const manualUploadDocumentFromMicrosoft = async (data) => {
  try {
    const response = await Instance.post(
      `${API.UPLOAD_DOCUMENT_MICROSOFT_MANUAL}`,
      data,
    );
    if (response.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response.data.message;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
    return error;
  }
};

export const createToken = async (id) => {
  try {
    const response = await Instance.patch(`${API.CREATE_TOKEN}/${id}`);
    return response?.data?.token;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const microSoftUploadFlow = async () => {
  try {
    return await Instance.get(`${API.MICROSOFT_UPLOAD}`);
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const googleUploadFlow = async () => {
  try {
    return await Instance.get(`${API.GOOGLE_UPLOAD}`);
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const manualUploadFromGmail = async (data) => {
  try {
    const response = await Instance.post(
      `${API.UPLOAD_DOCUMENT_GOOGLE_MANUAL}`,
      data,
    );
    if (response.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
    return error;
  }
};
